import { NO_CONTENT } from 'http-status-codes';
import { noInternetChecker } from 'store/networkMiddleware/axiosClients';

/**
 * Creates a function that will return the correct phrase based on the amount of elements.
 *
 * @param singular the phrase in singular
 * @param plural  the phrase in plural
 * @param other a default phrase for other cases (plural will be use if this is not provided)
 * @returns string
 */
export const getTextPluralized = (singular: string, plural: string, other?: string) => {
  return (number?: number) => {
    if (!number) return other || plural;
    if (number === 1) return singular;
    return plural;
  };
};

/**
 * Verifies that we are in a disconnected state
 */
export const verifyHasNoInternet = async (): Promise<boolean> => {
  let ret = true;

  try {
    const checkRes = await noInternetChecker.head('generate_204');
    if (checkRes?.status === NO_CONTENT) {
      ret = false;
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return ret;
};

/**
 * Verifies that it is a valid email
 */
export const isValidEmail = (email: string): boolean => {
  const regex = new RegExp(/^\S+@\S+\.\S+$/);
  return regex.test(email);
};
